import {
  useDescriptionFromBackoffice,
  metaDescription,
  metaTitle,
  useTitleFromBackoffice,
  scriptsHead,
} from '../../_config';

import { publicRuntimeConfig } from './runtime';

export const headConfig = () => {
  const { appName } = publicRuntimeConfig();

  const scriptsHeadDefault: any = [...scriptsHead];

  if (process.env.NEW_RELIC_SCRIPT && process.env.BUILD_STAGE === 'yes') {
    scriptsHeadDefault.push({
      src: process.env.NEW_RELIC_SCRIPT,
      defer: true,
      async: true,
      hid: 'new-relic-id',
    });
  }

  const htmlAttrs: any = {
    class: 'html-app-' + appName.toLowerCase(),
  };

  if (process.env.THEME_DEFAULT_LANGUAGE) {
    htmlAttrs.lang = process.env.THEME_DEFAULT_LANGUAGE;
  }

  function getSeoDefaultPageTitle() {
    if (useTitleFromBackoffice) {
      return process.env.THEME_SEO_PAGE_TITLE || metaTitle;
    }

    return metaTitle;
  }

  function getSeoDefaultPageDescription() {
    if (useDescriptionFromBackoffice) {
      return process.env.THEME_SEO_PAGE_DESCRIPTION || metaDescription;
    }

    return metaDescription;
  }

  return {
    scriptsHead: scriptsHeadDefault,
    htmlAttrs,
    seoDefaultPageTitle: getSeoDefaultPageTitle(),
    seoDefaultPageDescription: getSeoDefaultPageDescription(),
  };
};
